/*
 * ByLamari: Warenkorb des übertragenen Hydrogen-Neubaus (Theme-Kopie B, 25.10.2026), über Shopifys Ajax-API.
 *  - Hinzufügen (Plus-Knopf, Produktseite, Vorschläge, „Beide dazu“ mit einem Aufruf), Menge, Entfernen
 *  - danach die Warenkorb-Leiste (sections/bl-warenkorb) und auf /cart die Seite neu holen (Section Rendering API)
 *  - Zahl im Kopf, Gratis-Ring-Preise (lib/dritter-ring.ts) und Ansage für Bildschirmleser aktualisieren
 *  - Mystery-Geschenk (0-€-Variante 53831940145418): kommt beim Klick auf „Zur Kasse“ dazu, wird ohne bezahlte
 *    Artikel entfernt und nie mehr als 1 Stück (components/WarenkorbExtras.tsx, live: snippets/bylamari-page-skin);
 *    „Zur Kasse“ geht spätestens nach 4 Sekunden zur Kasse, auch ohne Geschenk
 */
(function () {
  var BL = (window.BL = window.BL || {});
  var GESCHENK = 53831940145418;
  var statusEl = document.querySelector('[data-cart-status]');
  var laeuft = 0;

  function ansage(t) { if (statusEl) statusEl.textContent = t; }
  function json(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) { var f = new Error(d.description || d.message || 'Fehler'); f.daten = d; throw f; }
        return d;
      });
    });
  }
  function seitenSektion() {
    var s = document.querySelector('[data-bl-wk-seite]');
    var w = s && s.closest('.shopify-section');
    return w ? w.id.replace('shopify-section-', '') : null;
  }
  function geld(cent) { return (cent / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }

  function kopf(cart) {
    var menge = 0;
    cart.items.forEach(function (i) { if (i.variant_id !== GESCHENK) menge += i.quantity; });
    var label = menge === 0 ? 'Warenkorb, leer' : menge === 1 ? 'Warenkorb, 1 Artikel' : 'Warenkorb, ' + menge + ' Artikel';
    document.querySelectorAll('[data-bl-wk-knopf]').forEach(function (a) {
      a.setAttribute('aria-label', label);
      var z = a.querySelector('.bl-cart-count');
      if (menge > 0) {
        if (!z) { z = document.createElement('span'); z.className = 'bl-cart-count'; z.setAttribute('aria-hidden', 'true'); a.appendChild(z); }
        z.textContent = menge > 99 ? '99+' : String(menge);
      } else if (z) z.remove();
    });
    document.querySelectorAll('[data-bl-wk-ansage]').forEach(function (s) { s.textContent = label; });
  }

  /* Gratis-Ring: 2, 5, 8 … Ringe im Warenkorb, dann kostet der nächste 0 € (bis zum günstigsten Ring). */
  function gratisMax(cart) {
    var ringe = 0, min = -1;
    cart.items.forEach(function (i) {
      if (i.variant_id === GESCHENK || i.product_type !== 'Ring' || i.quantity < 1) return;
      ringe += i.quantity;
      var stk = i.original_line_price / i.quantity;
      if (min < 0 || stk < min) min = stk;
    });
    return ringe % 3 === 2 ? min : -1;
  }
  BL.gratisMax = -1;
  function gratisPreise(cart) {
    var max = gratisMax(cart);
    BL.gratisMax = max;
    document.querySelectorAll('[data-bl-gp]').forEach(function (el) {
      var cent = parseInt(el.getAttribute('data-cent'), 10);
      var gratis = el.getAttribute('data-aktiv') !== 'false' && max >= 0 && cent <= max;
      var war = !el.classList.contains('bl-gratis-preis--normal');
      if (gratis === war) return;
      if (!el._blNormal) el._blNormal = war ? null : el.innerHTML;
      if (gratis) {
        if (!el._blNormal) el._blNormal = el.innerHTML;
        el.innerHTML = '<s class="bl-gratis-preis__alt"><span class="sr-only">Statt: </span>' + geld(cent) + '</s> <span class="bl-gratis-preis__neu"><span class="sr-only">Mit Kaufe 3, zahl 2: </span>0,00 €</span>';
        el.classList.remove('bl-gratis-preis--normal');
      } else {
        el.innerHTML = el._blNormal || ('<span class="sr-only">Preis: </span>' + geld(cent));
        el.classList.add('bl-gratis-preis--normal');
      }
      el.classList.remove('is-wechsel'); void el.offsetWidth; el.classList.add('is-wechsel');
    });
    document.dispatchEvent(new CustomEvent('bl:gratis', { detail: { max: max } }));
  }

  function aufraeumen(cart) {
    var g = null, bezahlt = 0;
    cart.items.forEach(function (i) { if (i.variant_id === GESCHENK) g = i; else bezahlt += i.quantity; });
    if (!g) return null;
    if (bezahlt === 0) return json('/cart/change.js', { id: g.key, quantity: 0 });
    if (g.quantity > 1) return json('/cart/change.js', { id: g.key, quantity: 1 });
    return null;
  }

  function sektionen() {
    var ids = ['bl-warenkorb'];
    var seite = seitenSektion();
    if (seite) ids.push(seite);
    return ids;
  }
  function einsetzen(ids, s) {
    ids.forEach(function (id) {
      var alt = document.getElementById('shopify-section-' + id);
      if (!alt || !s || !s[id]) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = s[id];
      var neuEl = tmp.firstElementChild;
      if (neuEl) alt.replaceWith(neuEl);
    });
  }
  /* Nach einer Änderung: Sektionen kommen direkt mit der Antwort von add.js/change.js (sonst sieht Shopify
     die Änderung beim nächsten Abruf manchmal noch nicht), Zahl und Gratis-Preise aus /cart.js. */
  function nachAenderung(antwort) {
    var ids = sektionen();
    return json('/cart.js').then(function (cart) {
      var auf = aufraeumen(cart);
      if (auf) return auf.then(function () { return neu(); });
      if (!antwort || !antwort.sections) return neu();
      kopf(cart);
      gratisPreise(cart);
      einsetzen(ids, antwort.sections);
      document.dispatchEvent(new CustomEvent('bl:warenkorb', { detail: { cart: cart } }));
      return cart;
    });
  }
  function neu() {
    var ids = sektionen();
    return json('/cart.js').then(function (cart) {
      var auf = aufraeumen(cart);
      return (auf ? auf.then(function () { return json('/cart.js'); }) : Promise.resolve(cart));
    }).then(function (cart) {
      kopf(cart);
      gratisPreise(cart);
      return fetch(location.pathname + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (s) {
          einsetzen(ids, s);
          document.dispatchEvent(new CustomEvent('bl:warenkorb', { detail: { cart: cart } }));
          return cart;
        });
    });
  }
  BL.warenkorbNeu = neu;

  function fehlerZeigen(f) {
    var box = document.querySelector('[data-bl-wk-fehler]');
    var text = (f && f.message) || 'Das hat leider nicht geklappt. Bitte versuch es gleich noch einmal.';
    if (box) { box.textContent = text; box.hidden = false; }
    return text;
  }

  /* Öffentlich: in den Warenkorb legen. items = [{ id, quantity }] */
  BL.inDenWarenkorb = function (items, optionen) {
    optionen = optionen || {};
    laeuft++;
    ansage('Warenkorb wird aktualisiert');
    return json('/cart/add.js', { items: items, sections: sektionen().join(','), sections_url: location.pathname })
      .then(function (d) { return nachAenderung(d); })
      .then(function (cart) {
        ansage('Warenkorb aktualisiert');
        if (optionen.oeffnen !== false && BL.oeffne) BL.oeffne('cart-drawer');
        return cart;
      })
      .finally(function () { laeuft--; });
  };
  BL.menge = function (key, menge) {
    laeuft++;
    ansage('Warenkorb wird aktualisiert');
    return json('/cart/change.js', { id: key, quantity: Math.max(0, menge), sections: sektionen().join(','), sections_url: location.pathname })
      .then(function (d) { return nachAenderung(d); })
      .then(function (c) { ansage('Warenkorb aktualisiert'); return c; })
      .finally(function () { laeuft--; });
  };

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-bl-schnellkauf], [data-bl-hinzu-form]')) {
      e.preventDefault();
      var id = parseInt(f.querySelector('[name="id"]').value, 10);
      var knopf = f.querySelector('button');
      if (knopf) knopf.setAttribute('aria-busy', 'true');
      BL.inDenWarenkorb([{ id: id, quantity: 1 }], { oeffnen: f.hasAttribute('data-bl-schnellkauf') || !f.closest('dialog') })
        .then(function () {
          var m = f.parentElement && f.parentElement.querySelector('[data-bl-meldung]');
          if (m) m.textContent = f.getAttribute('data-meldung') || '';
        })
        .catch(fehlerZeigen)
        .finally(function () { if (knopf) knopf.removeAttribute('aria-busy'); });
      return;
    }
    if (f.matches('[data-bl-menge-form]')) {
      e.preventDefault();
      var key = f.querySelector('[name="id"]').value;
      var s = e.submitter;
      var feld = f.querySelector('[data-bl-menge-feld]');
      var menge = s && s.name === 'quantity' && !s.hasAttribute('data-bl-setzen') ? parseInt(s.value, 10) : parseInt(feld.value, 10);
      if (!isFinite(menge)) return;
      var zeile = f.closest('.bl-wk__zeile');
      if (zeile) { zeile.classList.add('is-pending'); zeile.setAttribute('aria-busy', 'true'); }
      BL.menge(key, menge).catch(function (err) {
        if (zeile) { zeile.classList.remove('is-pending'); zeile.removeAttribute('aria-busy'); }
        var p = zeile && zeile.querySelector('[data-bl-zeile-fehler]');
        if (p) { p.textContent = err.message; p.hidden = false; } else fehlerZeigen(err);
      });
    }
  });
  document.addEventListener('change', function (e) {
    var feld = e.target.closest && e.target.closest('[data-bl-menge-feld]');
    if (!feld) return;
    var f = feld.closest('form');
    if (f) f.requestSubmit(f.querySelector('[data-bl-setzen]') || undefined);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var beide = t.closest && t.closest('[data-bl-beide]');
    if (beide) {
      if (beide.disabled) return;
      var ids = beide.getAttribute('data-bl-beide').split(',');
      var text = beide.textContent;
      beide.disabled = true;
      beide.textContent = 'Kommt in den Warenkorb …';
      BL.inDenWarenkorb(ids.map(function (i) { return { id: parseInt(i, 10), quantity: 1 }; }), { oeffnen: false })
        .catch(function () {
          beide.disabled = false; beide.textContent = text;
          var p = beide.parentElement.querySelector('[data-bl-beide-fehler]');
          if (p) { p.textContent = 'Das hat leider nicht geklappt. Bitte versuch es gleich noch einmal.'; p.hidden = false; }
        });
      return;
    }
    var info = t.closest && t.closest('[data-bl-geschenk-info]');
    if (info) {
      var tip = info.closest('.bl-wk__details').querySelector('[data-bl-geschenk-tip]');
      var offen = tip.hidden;
      tip.hidden = !offen;
      info.setAttribute('aria-expanded', String(offen));
      return;
    }
    var zu = t.closest && t.closest('[data-bl-geschenk-zu]');
    if (zu) {
      var tip2 = zu.closest('[data-bl-geschenk-tip]');
      tip2.hidden = true;
      var i2 = tip2.closest('.bl-wk__details').querySelector('[data-bl-geschenk-info]');
      if (i2) i2.setAttribute('aria-expanded', 'false');
      return;
    }
    var weiter = t.closest && t.closest('[data-bl-weiter]');
    if (weiter) {
      var d = weiter.closest('dialog');
      if (d && d.open) { e.preventDefault(); d.close(); }
      return;
    }
    var kasse = t.closest && t.closest('[data-bl-kasse]');
    if (kasse) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      if (kasse.getAttribute('aria-busy') === 'true') return;
      kasse.setAttribute('aria-busy', 'true');
      var tx = kasse.querySelector('[data-bl-kasse-text]');
      if (tx) tx.textContent = 'Einen Moment …';
      // Die Kasse geht vor dem Geschenk (Neubau, Prüfung 31.10.2026, M2): nach dem Hinzufügen, ob mit oder ohne
      // Erfolg, und spätestens nach 4 Sekunden zur Kasse, auch wenn eine Anfrage hängt
      var weg = false, uhr = setTimeout(function () { los(); }, 4000);
      var los = function () { if (weg) return; weg = true; clearTimeout(uhr); window.location.href = '/checkout'; };
      json('/cart.js').then(function (cart) {
        var g = null, bezahlt = 0;
        cart.items.forEach(function (i) { if (i.variant_id === GESCHENK) g = i; else bezahlt += i.quantity; });
        if (bezahlt > 0 && !g) return json('/cart/add.js', { items: [{ id: GESCHENK, quantity: 1 }] });
        if (g && g.quantity > 1) return json('/cart/change.js', { id: g.key, quantity: 1 });
      }).catch(function () {}).then(los);
    }
  });

  // Zurück aus der Kasse (Seite aus dem Speicher): Knopf und Geschenk wieder in Ordnung bringen
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) neu().catch(function () {});
  });
  // Beim Laden: Geschenk aufräumen, falls nötig (ohne die Leiste neu zu holen, wenn nichts zu tun ist)
  json('/cart.js').then(function (cart) {
    BL.gratisMax = gratisMax(cart);
    var auf = aufraeumen(cart);
    if (auf) auf.then(function () { return neu(); }).catch(function () {});
  }).catch(function () {});
})();